import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";
import { FC } from "react";
import { Container } from "~/components/Container";
import { Resource } from "~/services/resource";
import Trans from "~/types/translationKeys";
import styles from "./ResourceVideoDetails.module.scss";
const ReactPlayer = dynamic(() => import("react-player"), { ssr: false });

interface ResourceVideoDetails {
  resource: Resource;
}

const ResourceVideoDetails: FC<ResourceVideoDetails> = ({ resource }) => {
  const { t } = useTranslation();

  return (
    <section className={styles.resource_video_details}>
      <div className={styles.header}>
        <Container className={styles.container}>
          <p className={styles.category} data-aos="fade-down">
            {t(Trans.product_videos)}
          </p>
          <h1 className={styles.title} data-aos="fade-up">
            {resource.name}
          </h1>
        </Container>
      </div>

      <div className={styles.video} data-aos="fade-up">
        <Container className={styles.container}>
          <ReactPlayer
            url={resource.video}
            controls
            width="100%"
            height="100%"
            loop
            playing
            style={{ borderRadius: 16, overflow: "hidden" }}
          />
        </Container>
      </div>
    </section>
  );
};

export default ResourceVideoDetails;
